import React, { forwardRef } from "react";
// import "./Checkbox.css";
import styled from "@emotion/styled";
import { Typography } from "../Typography";
import * as tokens from "../../design-tokens/tokens/tokens";

interface CheckboxProps extends React.ComponentPropsWithoutRef<"input"> {
  label?: string;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className = "", label, ...otherProps }, ref) => {
    return (
      <StyledLabel className={`checkbox ${className}`}>
        <StyledInput type="checkbox" ref={ref} {...otherProps} />
        <Typography>{label}</Typography>
      </StyledLabel>
    );
  }
);

const StyledLabel = styled.label`
  display: flex;
  gap: 8px;
`;

const StyledInput = styled.input`
  cursor: pointer;

  &[type="checkbox"] {
    appearance: none;

    background-color: ${tokens.WHITE};

    margin: 0;

    font: inherit;
    color: ${tokens.BRAND_HEROBLUE};
    width: 24px;
    height: 24px;
    border: 2px solid ${tokens.BRAND_HEROBLUE};
    border-radius: 3px;

    display: grid;
    place-content: center;
  }

  &[type="checkbox"]:checked {
    background-color: ${tokens.BRAND_HEROBLUE};
  }

  &[type="checkbox"]:focus {
    outline: max(2px, 0.15em) solid ${tokens.BRAND_HEROBLUE};
    outline-offset: max(2px, 0.15em);
  }

  &[type="checkbox"]:disabled {
    color: ${tokens.TINTS_OFF_WHITE_30};
    border: 2px solid ${tokens.TINTS_OFF_WHITE_30};
    background-color: ${tokens.TINTS_HERO_BLUE_90};
    cursor: not-allowed;
  }

  &[type="checkbox"]::before {
    content: "";
    width: 14px;
    height: 14px;
    transform: scale(0);
    transition: 100ms transform ease-in-out;

    box-shadow: inset 14px 14px ${tokens.WHITE};
    clip-path: polygon(40% 72%, 14% 49%, 3% 62%, 41% 97%, 100% 22%, 88% 11%);
  }

  &[type="checkbox"]:checked::before {
    transform: scale(1);
  }
`;

export { Checkbox };
export type { CheckboxProps };
